import React, { useState } from "react";
import LaddaButton from "../../../components/buttons/laddaButton";
import { icons } from "../../../constants";
import { opportunityTreatmentAction, opportunityState } from "../../../constants/selectData";
import { useForm } from "react-hook-form";
import { CustomTabPanel } from "../../../components/tabComponent";
import TreatmentDetailsModal from "./treatmentDetailsModal";
import EditOpportunityValuationModal from "./EditOpportunityValuationModal";
import { formatMonthYear } from "../../../utils/dateUtils";
import { StyledTooltip } from "../../../components/toolltipComponent";
import ModalComponentOpportunityHelp from "../../createOpportunity/modalOpportunityHelp";
import { opportunityHelpIds } from "../../createOpportunity/opportunityHelpData";
import { getOpportunityLevelInfo } from "../tabDetails";
import "../../createOpportunity/styles.css";
import "../../riskDetails/styles.css";

const getImpactLabel = (value) => {
  const v = parseInt(value, 10);
  const map = { 1: "Insignificante", 2: "Menor", 3: "Moderado", 4: "Mayor", 5: "Enorme" };
  return map[v] || "";
};

const getProbabilityLabel = (value) => {
  const v = parseInt(value, 10);
  const map = { 1: "Raro", 2: "Improbable", 3: "Posible", 4: "Probable", 5: "Casi seguro" };
  return map[v] || "";
};

const getVulnerabilityLabel = (value) => {
  const v = parseInt(value, 10);
  const map = { 1: "Baja", 3: "Media", 5: "Alta" };
  return map[v] || "";
};

const TreatmentDetailsTab = ({
  data,
  getOpportunityData,
  isEditionAvailable,
  updateRiskupdateDate
}) => {
  const [treatmentDetailModal, setTreatmentDetailModal] = useState(false);
  const [valuationModalOpen, setValuationModalOpen] = useState(false);
  const [openModal, setOpenModal] = useState(null);
  const [helpId, setHelpId] = useState(null);

  const handleClose = () => {
    setTreatmentDetailModal(false);
  };

  const handleCloseValuationModal = () => setValuationModalOpen(false);

  const { setValue } = useForm({
    defaultValues: {}
  });

  const hasNewLevelData =
    data?.vulnerability != null &&
    data?.vulnerability !== "" &&
    data?.impactLevel != null &&
    data?.probability != null;

  const opportunityLevelInfo = hasNewLevelData
    ? getOpportunityLevelInfo(data?.opportunityLevel)
    : { class: "default-level", textClass: "default-level-text", text: "Sin nivel" };

  const OpportunityLevelComponent = () => (
    <StyledTooltip
      title={
        <>
          <div className="HContainer">
            <p className="toolkit-title">Impacto:</p>
            <p className="toolkit-content">{getImpactLabel(data?.impactLevel)}</p>
          </div>
          <div className="HContainer">
            <p className="toolkit-title">Vulnerabilidad:</p>
            <p className="toolkit-content">{getVulnerabilityLabel(data?.vulnerability)}</p>
          </div>
          <div className="HContainer">
            <p className="toolkit-title">Probabilidad:</p>
            <p className="toolkit-content">{getProbabilityLabel(data?.probability)}</p>
          </div>
        </>
      }
      followCursor
    >
      <div className={`level ${opportunityLevelInfo.class}`}>
        <p className={opportunityLevelInfo.textClass}>{opportunityLevelInfo.text}</p>
      </div>
    </StyledTooltip>
  );

  const openTreatmentDetailModal = () => {
    setTreatmentDetailModal(true);
    setValue("treatmentAction", data?.treatmentAction);
    setValue("activityStartDate", data?.activityStartDate);
    setValue("actionState", data?.actionState);
    setValue("responsible", data?.responsible);
  };

  return (
    <div>
      <CustomTabPanel value="1">
        <div className="header-titles">
          <div className="header-titles-item">
            <h2 className="gm-title" style={{ marginRight: "15px" }}>
              Estado:
            </h2>
            <p className="content-text">
              {data?.state
                ? opportunityState.find((item) => item.value === data.state)?.name
                : ""}
            </p>
          </div>
          <div className="header-titles-item">
            <h2 className="gm-title" style={{ marginRight: "15px" }}>
              Fecha de Identificación:
            </h2>
            <p className="content-text">
              {data?.creationDate ? formatMonthYear(data?.creationDate) : ""}
            </p>
          </div>
          <div className="header-titles-item"></div>
          <div className="header-titles-item align-center IHContainer">
            <div className="IHContainer align-center">
              <p className="create-label ml-0">Valoración Global:</p>
              <div
                className="pointer align-center j-center ml-5"
                onClick={() => {
                  setHelpId(opportunityHelpIds.OPPORTUNITY_LEVEL);
                  setOpenModal(true);
                }}
              >
                <img
                  className="btn-add-icon"
                  src={icons.infoExclamation}
                  alt="icon"
                  style={{ width: "30px" }}
                />
              </div>
            </div>
            <div className="IHContainer align-center" style={{ gap: "12px", flexWrap: "wrap" }}>
              <OpportunityLevelComponent />
          
          
                {isEditionAvailable && (
                  <button
                    type="button"
                    className="edit-valuation-btn-circle"
                    onClick={() => setValuationModalOpen(true)}
                    title="Editar valoración"
                    aria-label="Editar valoración"
                  >
                    <img className="btn-icon" src={icons.editBlack} alt="Editar" />
                  </button>
                )}
             
            
            </div>
          </div>
        </div>

        <div className="IHContainer align-center">
          <h2 className="gm-title">Acción de Tratamiento:</h2>
          <div
            className="pointer align-center j-center ml-5"
            onClick={() => {
              setHelpId(opportunityHelpIds.TREATMENT_ACTION);
              setOpenModal(true);
            }}
          >
            <img
              className="btn-add-icon"
              src={icons.infoExclamation}
              alt="icon"
              style={{ width: "30px" }}
            />
          </div>
        </div>
        <p className="content-text">
          {data?.treatmentAction
            ? opportunityTreatmentAction.find(
                (item) => item.value === data?.treatmentAction || item.value === parseInt(data?.treatmentAction, 10)
              )?.name
            : ""}
        </p>
        <div className="header-titles-item">
          <h2 className="gm-title">Fecha de Inicio de Actividades:</h2>
          <p className="content-text">
            {data?.activityStartDate
              ? formatMonthYear(data?.activityStartDate)
              : ""}
          </p>
        </div>
        <h2 className="gm-title">Responsable:</h2>
        <p className="content-text">{data?.responsible}</p>

        <div className="IHContainer align-center">
          <div style={{ margin: 0 }} className="tab-pill">
            Estado de la Acción:
          </div>
          <p style={{ marginLeft: "20px" }}>
            {data?.actionState == 1
              ? "Abierta"
              : data?.actionState == 2
              ? "Cerrada"
              : ""}
          </p>
        </div>

        <div className="j-center mt-20">
          {isEditionAvailable && (
            <LaddaButton
              variant="contained"
              onClick={() => {
                openTreatmentDetailModal();
              }}
            >
              <div className="IHContainer align-rigth">
                <img
                  className="btn-icon"
                  src={icons.editWhite}
                  alt="icon"
                  style={{ marginRight: "10px" }}
                />
                <p className="button_text">Editar</p>
              </div>
            </LaddaButton>
          )}
        </div>
      </CustomTabPanel>
      <TreatmentDetailsModal
        open={treatmentDetailModal}
        handleClose={handleClose}
        data={data}
        getOpportunityData={getOpportunityData}
        updateRiskupdateDate={updateRiskupdateDate}
      />
      <EditOpportunityValuationModal
        open={valuationModalOpen}
        handleClose={handleCloseValuationModal}
        data={data}
        getOpportunityData={getOpportunityData}
        updateRiskupdateDate={updateRiskupdateDate}
      />
      <ModalComponentOpportunityHelp
        openModal={openModal}
        handleClose={() => setOpenModal(false)}
        helpId={helpId}
      />
    </div>
  );
};

export default TreatmentDetailsTab;
